import {CompleteColumnSettings, PersistedItemValue} from '../EditableTable/types';
import React, {useState, ReactElement} from 'react';
import {useField} from 'formik';
import AccessibleTypeahead from '../../../../shared/components/accessible-typeahead';
import {collegeQueryResults} from '../../../../shared/actions/college-typeaheads';

const CollegeSelector = (props: {
  column: CompleteColumnSettings<PersistedItemValue>;
}): ReactElement => {
  const [, , helpers] = useField(props.column.name);
  const [collegeName, setCollegeName] = useState<string>('');

  return (
    <AccessibleTypeahead
      id="formik-college-selector-typeahead"
      placeholder="e.g. City College of San Francisco"
      value={collegeName}
      onSearch={(query) => collegeQueryResults(query)}
      onInputChange={(text) => {
        setCollegeName(text);
      }}
      onSelect={(result) => {
        helpers.setValue(result.ncesId);
        setCollegeName(result.text);
      }}
    />
  );
};

export default CollegeSelector;
